import { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { messagingPromise, getToken } from "../services/firebase";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/dashboard";
    const [loading, setLoading] = useState(false);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

    
        try {
            // FCM 지원 환경에서 토큰 발급 (로그인과 독립)
            let fcmToken = null;

            try {
                const messaging = await messagingPromise;

                if (messaging) {
                    fcmToken = await getToken(messaging, {
			        vapidKey: "BJ-eFo62LRTTcPZiDzYTlbUj0_DrXqzrkuYLp10Xm5dDTiDzQb4ALOgpQS_PAwrsZbWP-RKy7d7vwT6qOjaz0TQ",
                    });
                    console.log("FCM 토큰 발급 성공");
                } else {
                    console.log("[CLONE] FCM 미지원 환경: 토큰 발급 보류");
                }
            } catch (fcmError) {
                console.warn("FCM 토큰 발급 실패, 로그인은 계속 진행:", fcmError);
            }

            // 로그인 요청
            const res = await axios.post(
                //"http://172.16.2.71:1515/login",
                //"https://safemap-api.smsoft.co.kr/login",
                `${API_BASE_URL}/login`,
                {
                    username,
                    password,
                    fcm_token: fcmToken, // FCM 토큰 전달
                },
                { withCredentials: true }
            );

            console.log("로그인 성공:", res.data);

            if (res.data.success) {
                alert("로그인 성공");
                localStorage.setItem("token", res.data.access_token);
                navigate(from, { replace: true });
            } else {
                alert(res.data.message);
            }

        } catch (err) {
            console.error("로그인 에러:", err);
            alert("서버와 통신 중 문제가 발생했습니다.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginpage">
            <form className="inpbox" onSubmit={handleSubmit}>
                <h1><img src="/media/logo.png" alt="" /></h1>
                <div className="icell01 icell">
                    <span><label htmlFor="userid">아이디</label></span>
                    <input 
                        type="text" 
                        name="username" 
                        id="userid" 
                        autoComplete="off" 
                        placeholder="아이디 입력" 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)} 
                    />
                </div>
                <div className="icell02 icell">
                    <span><label htmlFor="userpw">비밀번호</label></span>
                    <input 
                        type="password" 
                        name="password" 
                        id="userpw" 
                        autoComplete="off" 
                        placeholder="비밀번호 입력" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                    />
                </div>
                <div className="btnwrp clear_fix">
                    <button type="submit" className="subtn">로그인</button>
                </div>
            </form>
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner" />
                </div>
            )}
        </div>
    );
}


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate, useLocation } from "react-router-dom";
// //import { messaging, android_token } from "../services/FireBase";
// import { useMessage } from "../contexts/MessageContext";


// export default function Login() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation();
//   const from = location.state?.from?.pathname || "/dashboard";
//   const { setMessage } = useMessage();
//   const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         setTimeout(() => {
//             if (window.Android && typeof window.Android.sendMessage === 'function') {
//                 window.Android.sendMessage("React에서 보낸 메세지");
//                 console.log("앱으로 메시지 보냄");
//             } else {
//                 console.log("❌ Android 인터페이스가 없습니다.");
//             }
//         }, 500);

//         window.receiveFromAndroid = function (msg) {
//         console.log("안드로이드에서 받은 메시지:", msg);

//   // token 저장(기존 로직 유지)
// //   if (msg && msg !== "null" && msg !== "undefined" && msg.length > 0) {
// //     localStorage.setItem("android_token", msg);
// //     console.log("LocalStorage에 android_token 저장 완료");
// //   } else {
// //     console.log("Token이 비어있거나 유효하지 않음");
// //   }

//   // 알림 메시지인지 JSON 파싱 시도 후 확인
// //   let messageObj = null;
// //   try {
// //     messageObj = JSON.parse(msg);
// //   } catch (e) {
// //     // JSON 파싱 실패 -> msg는 알림 메시지 아닐 가능성 높음
// //   }

// //   if (messageObj && messageObj.title && messageObj.body) {
// //     setMessage(messageObj);
// //     console.log("알림 메시지로 setMessage 호출함", messageObj);
// //   } else {
// //    // console.log("알림 메시지가 아니어서 setMessage 호출 안 함");
// //     // 필요하면 여기서 setMessage(null) 해도 됨
// //   }
// };


//         // window.onerror = function (message, source, lineno, colno, error) {
//         //     console.error("Global JS Error:", { message, source, lineno, colno, error });
//         // };
//         // const savedToken = localStorage.getItem("android_token");
//         // console.log("savedToken", savedToken);
//         // if (savedToken) {
//         //     console.log("이전에 저장된 android_token:", savedToken.substring(0, 10) + "...");
//         // }

//     }, [setMessage]);

//     //수정 끝

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         try {        
//             const androidToken = localStorage.getItem("android_token");
//             const res = await axios.post(
//                  "http://172.16.2.71:1515/login",
//                  //"https://safemap-api.smsoft.co.kr/login",
//                 { username, password, fcm_token: androidToken },
//                 { withCredentials: true }
//             );

//             console.log("로그인 성공:", res.data);

//             if (res.data.success) {
//                 alert("로그인 성공");
//                 localStorage.setItem("token", res.data.access_token);
//                 console.log("로그인 시점의 android_token:", androidToken ? androidToken : "없음");                
//                 navigate(from, { replace: true });
//             } else {
//                 alert(res.data.message);
//             }
//         } catch (err) {
//             console.error("로그인 에러:", err);
//             alert("서버와 통신 중 문제가 발생했습니다.");
//         } finally {
//         setLoading(false); // ✅ 로딩 종료
//         }
//     };

//     return (
//         <div className="loginpage">
//             <form className="inpbox" onSubmit={handleSubmit}>
//                 <h1><img src="/media/logo.png" alt="" /></h1>
//                 <div className="icell01 icell">
//                     <span><label htmlFor="userid">아이디</label></span>
//                     <input 
//                         type="text" 
//                         name="username" 
//                         className="userid" 
//                         id="userid" 
//                         autoComplete="off" 
//                         title="아이디" 
//                         placeholder="아이디 입력" 
//                         value={username} 
//                         onChange={(e) => setUsername(e.target.value)} 
//                     />
//                 </div>
//                 <div className="icell02 icell">
//                     <span><label htmlFor="userpw">비밀번호</label></span>
//                     <input 
//                         type="password" 
//                         name="password" 
//                         className="userpw" 
//                         id="userpw" 
//                         autoComplete="off" 
//                         title="비밀번호" 
//                         placeholder="비밀번호 입력" 
//                         value={password} 
//                         onChange={(e) => setPassword(e.target.value)} 
//                     />
//                 </div>
//                 <div className="btnwrp clear_fix">
//                     <button type="submit" title="확인" className="subtn">로 그 인</button>
                    
//                 </div>
//             </form>
//             {loading && (
//             <div className="loading-overlay">
//                 <div className="spinner" />
//             </div>
//             )}
//         </div>
//     );
    
// }

